import { useEffect } from 'react';
import ws from 'utils/ws';

const RetiredOrganizationDashboard = () => {
  useEffect(() => {
    window.location.replace(ws.insight2Url('/dashboard/'));
  }, []);

  return null;
};

export default RetiredOrganizationDashboard;
